import { fractionize } from './currencyTransforms'

export const numberToCurrency = (currency: string, amount: number, compact?: boolean) => {
  try {
    const fractionalized = fractionize(amount)
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: compact ? 0 : 2,
      notation: compact ? 'compact' : undefined
    })
    return formatter.format(fractionalized ?? 0)
  } catch {
    return amount ? amount / 100 : 0
  }
}
